if (!customElements.get('summer-sale-popup')) {
  customElements.define(
    'summer-sale-popup',
    class SummerSalePopup extends HTMLElement {
      connectedCallback() {
        this.delayMs = (parseInt(this.dataset.delaySeconds, 10) || 120) * 1000;
        this.suppressDays = parseInt(this.dataset.suppressDays, 10) || 7;
        this.designMode = this.dataset.designMode === 'true';
        this.seenKey = 'mirai_summer_sale_seen_at';
        this.elapsedKey = 'mirai_site_elapsed_ms';
        this.lastTickKey = 'mirai_site_last_tick';

        this.querySelectorAll('[data-summer-close]').forEach((el) =>
          el.addEventListener('click', (e) => {
            if (el.classList.contains('summer-sale__cta')) { this.dismiss(); return; }
            e.preventDefault();
            this.dismiss();
          })
        );
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.hasAttribute('open')) this.dismiss();
        });

        if (this.designMode) { this.open(); return; }
        if (this.isSuppressed()) return;
        this.startTimer();
      }

      store() {
        try { return window.localStorage; } catch (e) { return null; }
      }

      isSuppressed() {
        const ls = this.store();
        if (!ls) return false;
        const seen = parseInt(ls.getItem(this.seenKey), 10);
        if (!seen) return false;
        const ageDays = (Date.now() - seen) / 86400000;
        return ageDays < this.suppressDays;
      }

      startTimer() {
        const ls = this.store();
        let elapsed = 0;
        if (ls) elapsed = parseInt(ls.getItem(this.elapsedKey), 10) || 0;
        if (ls) ls.setItem(this.lastTickKey, String(Date.now()));

        this.tick = setInterval(() => {
          elapsed += 1000;
          if (ls) ls.setItem(this.elapsedKey, String(elapsed));
          if (elapsed >= this.delayMs) {
            clearInterval(this.tick);
            this.open();
          }
        }, 1000);
      }

      open() {
        this.removeAttribute('hidden');
        this.setAttribute('open', '');
      }

      dismiss() {
        this.removeAttribute('open');
        this.setAttribute('hidden', '');
        if (this.tick) clearInterval(this.tick);
        const ls = this.store();
        if (ls) ls.setItem(this.seenKey, String(Date.now()));
      }
    }
  );
}
